import { resolveDailyPromoItem } from '@/lib/assistant/resolveBusinessSpecialPromos';

function idKey(x) {
  return x == null || x === '' ? '' : String(x);
}

function normalizeLookup(s) {
  return String(s || '')
    .toLowerCase()
    .normalize('NFD')
    .replace(/\p{M}/gu, '')
    .replace(/[^\p{L}\p{N}\s]/gu, ' ')
    .replace(/\s+/g, ' ')
    .trim();
}

/**
 * Intenta mapear el texto del premio del club a un producto visible del menú.
 * Si no hay match claro, devuelve null (el saludo sigue mostrando solo el texto).
 */
export function resolveRewardProductFromMenu(rewardText, products) {
  const raw = String(rewardText || '').trim();
  if (!raw) return null;
  const visible = (products || []).filter((p) => p && p.availability !== 'hidden');
  if (visible.length === 0) return null;

  let q = normalizeLookup(raw.replace(/^\d+\s*([x×]\s*)?/i, '').trim());
  if (!q) q = normalizeLookup(raw);
  if (!q) return null;

  const exact = visible.find((p) => normalizeLookup(p.name) === q);
  if (exact) return exact;

  for (const p of visible) {
    const pn = normalizeLookup(p.name);
    if (pn.includes(q) && q.length >= 3) return p;
  }
  for (const p of visible) {
    const pn = normalizeLookup(p.name);
    if (q.includes(pn) && pn.length >= 3) return p;
  }

  const tokens = [...new Set(q.split(/\s+/).filter((t) => t.length >= 2))];
  if (tokens.length === 0) return null;

  let best = null;
  let bestScore = 0;
  for (const p of visible) {
    const blob = normalizeLookup(`${p.name} ${p.description || ''} ${p.category || ''}`);
    let score = 0;
    for (const t of tokens) {
      if (blob.includes(t)) score += t.length * (t.length >= 4 ? 2 : 1);
    }
    if (score > bestScore) {
      bestScore = score;
      best = p;
    }
  }

  const minScore = tokens.some((t) => t.length >= 4) ? 8 : tokens.length >= 2 ? 6 : 4;
  if (best && bestScore >= minScore) return best;
  return null;
}

/**
 * Cards opcionales del saludo: premio canjeable (producto resuelto) y promo del día.
 * Orden: premio primero, luego promo. Sin duplicar el mismo id.
 */
export function buildWelcomeSaludoProducts(menuData, benefitsProgress) {
  const prods = menuData?.products || [];
  const promos = menuData?.promos || [];
  const business = menuData?.business || {};
  const products = [];
  const seen = new Set();
  let includedReward = false;
  let includedDailyPromo = false;

  if (benefitsProgress?.enabled) {
    const ar = Math.max(0, Number(benefitsProgress.available_rewards) || 0);
    if (ar > 0) {
      const rt = String(benefitsProgress.reward_text || '').trim();
      const hit = rt ? resolveRewardProductFromMenu(rt, prods) : null;
      if (hit) {
        const k = idKey(hit.id);
        if (k && !seen.has(k)) {
          seen.add(k);
          products.push({
            ...hit,
            assistantWelcomeKind: 'club_reward',
            clubRewardDisplayLabel: rt,
          });
          includedReward = true;
        }
      }
    }
  }

  const dailyItem = resolveDailyPromoItem(menuData);
  if (dailyItem) {
    const k = idKey(dailyItem.id);
    if (k && !seen.has(k)) {
      seen.add(k);
      products.push(dailyItem);
      includedDailyPromo = true;
    }
  }

  return { products, includedReward, includedDailyPromo };
}

/** Quita metadatos solo del cliente antes de persistir en carrito / API. */
export function stripAssistantWelcomeProductMeta(product) {
  if (!product || typeof product !== 'object') return product;
  const { assistantWelcomeKind, clubRewardDisplayLabel, ...rest } = product;
  return rest;
}
